import Image from 'next/image';
import Link from 'next/link';
import type { ReactElement } from 'react';

export default function Logo(): ReactElement {
  return (
    <>
      <Link aria-label="alex logo" className="alex-logo" href={`/`}>
        <Image
          alt={'MyALEXHealth Logo'}
          data-testid="logo-image"
          height={29}
          src={'/mahlogo.png'}
          style={{ width: '100%', height: 'auto' }}
          width={211}
        />
      </Link>
    </>
  );
}
